module.exports = __webpack_public_path__ + "static/media/how-we-work-1-decor.808152bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/general/how-we-work-1-decor.svg
// module id = 320
// module chunks = 0